import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBellWhite = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M512 1024c56.32 0 102.4-46.080 102.4-102.4h-204.8c0 56.32 45.568 102.4 102.4 102.4zM819.2 716.8v-256c0-157.184-83.968-288.768-230.4-323.584v-34.816c0-42.496-34.304-76.8-76.8-76.8s-76.8 34.304-76.8 76.8v34.816c-146.944 34.816-230.4 165.888-230.4 323.584v256l-102.4 102.4v51.2h819.2v-51.2l-102.4-102.4z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgBellWhite);
export default ForwardRef;
